import React from 'react';
import './AddressCard.css';

const AddressCard = ({ address, onEdit, onDelete, onSetDefault, selectable, selected, onSelect }) => {
  return (
    <div 
      className={`address-card ${selected ? 'selected' : ''} ${address.isDefault ? 'default' : ''}`} 
      onClick={() => selectable && onSelect && onSelect(address)}
      style={{ cursor: selectable ? 'pointer' : 'default' }}
    >
      <div className="address-card__header">
        <h4>{address.name}</h4>
        {address.isDefault && <span className="badge badge-default">Default</span>}
        {selectable && selected && <span className="badge badge-selected">✓ Selected</span>}
      </div>
      <p className="address-card__phone">{address.phone}</p>
      <p className="address-card__full-address">
        {address.addressLine1}, {address.addressLine2 ? address.addressLine2 + ', ' : ''}
        {address.city}, {address.state} - {address.pincode}
      </p>
      
      {!selectable && (
        <div className="address-card__actions">
          <button className="btn-action" onClick={() => onEdit(address)}>Edit</button>
          <button className="btn-action btn-danger" onClick={() => onDelete(address._id)}>Delete</button>
          {!address.isDefault && (
            <button className="btn-action btn-outline" onClick={() => onSetDefault(address._id)}>Set Default</button>
          )}
        </div>
      )}
      
    </div>
  );
};

export default AddressCard;
